// Changing any color, needs to update the tooltip in directus 'provider.tenders.providerStatus'
export const PROVIDER_STATUS_METADATA = {
  invited: {color: '#4DA3FF', icon: 'pi pi-envelope'},
  accepted: {color: '#1E63FF', icon: 'pi pi-pencil'},
  prepared: {color: '#00C2E0', icon: 'pi pi-clock'},
  finished: {color: '#00D084', icon: 'pi pi-send'},
  won: {color: '#8CFF00', icon: 'pi pi-trophy'},
  waitingForCustomer: {color: '#FFB000', icon: 'pi pi-hourglass'},
  rejected: {color: '#FF6B6B', icon: 'pi pi-times-circle'},
  expired: {color: '#FF3D00', icon: 'pi pi-history'},
  lost: {color: '#D70022', icon: 'pi pi-times-circle'},
  neutral: {color: '#6C757D', icon: 'pi pi-minus-circle'},
} as const;

export type ProviderStatus = keyof typeof PROVIDER_STATUS_METADATA;

const PROVIDER_STATUS_KEY_PREFIX = 'provider.tenders.status.';

function resolveStatusKey(status?: string): ProviderStatus {
  if (!status) return 'neutral';

  const target = status.toLowerCase().replace(/_/g, '');
  const foundKey = (Object.keys(PROVIDER_STATUS_METADATA) as ProviderStatus[]).find(
    (key) => key.toLowerCase() === target,
  );

  return foundKey ?? 'neutral';
}

export function getProviderPhaseColor(status?: string): string {
  return PROVIDER_STATUS_METADATA[resolveStatusKey(status)].color;
}

export function getProviderPhaseIcon(status?: string): string {
  return PROVIDER_STATUS_METADATA[resolveStatusKey(status)].icon;
}

export function getProviderPhaseStatusKey(status?: string): string {
  return PROVIDER_STATUS_KEY_PREFIX + resolveStatusKey(status);
}

export function getAdminPhaseBarColor(
  phaseLocked: boolean,
  finished: number,
  inProgress: number,
): string {
  if (phaseLocked) {
    return PROVIDER_STATUS_METADATA.finished.color;
  }
  if (inProgress + finished > 0) {
    return PROVIDER_STATUS_METADATA.accepted.color;
  }
  return PROVIDER_STATUS_METADATA.neutral.color;
}
